import React, { useState, useCallback, useEffect } from 'react';
import PT from 'prop-types';
import cn from 'classnames';

import Icon from '../Icon/Icon';

const TabNav = ({ tabs = [], activeTabId: activeTabIdProp, onTabClick, className, indicationTabs }) => {
  const device = window.innerWidth < 756 ? 0 : 3;
  const widthTab = indicationTabs ? 125 : 100;
  const tabRange = Math.floor(window.innerWidth / device / widthTab);
  const [activeTabId, setActiveTabId] = useState(activeTabIdProp || tabs[0]?.id);
  const [navigationRange, setNavigationRange] = useState([0, tabRange]);
  const [addRangeBtn, setAddRangeBtn] = useState(false);
  const [removeRangeBtn, setRemoveRangeBtn] = useState(true);

  useEffect(() => {
    // if tabRange is updated, need to setNavigationRange
    setNavigationRange([0, tabRange]);
  }, [tabRange]);

  const addToRange = () => {
    const range = navigationRange[1] + tabRange;
    setRemoveRangeBtn(false);
    if (range >= tabs.length) {
      setAddRangeBtn(true);
    }
    return [navigationRange[1], range];
  };
  const removeFromRange = () => {
    const range = navigationRange[1] - tabRange;
    if (range <= tabRange) {
      setAddRangeBtn(false);
      setRemoveRangeBtn(true);
    }
    return [navigationRange[0] - tabRange, navigationRange[1] - tabRange];
  };

  const handleTabClick = useCallback(
    (tabClickedId) => (e) => {
      if (onTabClick) {
        onTabClick(tabClickedId, activeTabId, e);
      } else {
        setActiveTabId(tabClickedId);
      }
    },
    [onTabClick, activeTabId]
  );

  return (
    <div className="tab-nav__wrapper">
      <ul className={cn('tab-nav', className)}>
        {tabs.map(({ id, label }, index) => {
          let dataTestId = label.replace(/\s+/g, '');
          const isActive = activeTabIdProp ? activeTabIdProp === id : activeTabId === id;
          return (
            index >= navigationRange[0] &&
            index < navigationRange[1] && (
              <li
                data-testid={dataTestId}
                key={index}
                className={cn('tab-nav__item', {
                  'tab-nav__item--active': isActive,
                })}
                onClick={handleTabClick(id)}
              >
                <span className="tab-nav__link">{label}</span>
                {indicationTabs && <div className="tab-nav__indicator">{indicationTabs[id] || 0}</div>}
              </li>
            )
          );
        })}
        {tabs.length > tabRange && (
          <li className="tab-nav__navigation">
            <button
              className="tab-nav__navigation-item"
              disabled={removeRangeBtn}
              onClick={() => setNavigationRange(removeFromRange())}
            >
              <Icon className="icon-left" />
            </button>
            <button
              className="tab-nav__navigation-item"
              disabled={addRangeBtn}
              onClick={() => setNavigationRange(addToRange())}
            >
              <Icon className="icon-right" />
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

TabNav.propTypes = {
  tabs: PT.arrayOf(
    PT.shape({
      id: PT.oneOfType([PT.string, PT.number]),
      label: PT.oneOfType([PT.string, PT.number]),
    })
  ),
  activeTab: PT.string,
  onTabClick: PT.func,
  className: PT.string,
  indicationTabs: PT.object,
};

export default TabNav;
